import {LocaleContents} from "../types/types"

export const en_US: LocaleContents = {
    title: 'Recherchez votre séjour au ski',
    datepicker: {
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        firstDay: 1,
        winter: "Winter"
    },
    promoImg: 'https://www.travelski.com/Content/fr_220209145533_6203d5e5e8a4025b233b5867.png?ts=220209145949',

    startDate: 'Departure',
    endDate: 'Return',

    participants: 'Guests',
    adults: 'Adults',
    adult: 'Adult',
    children: 'Children',
    child: 'Child',

    childrenAgeAtTheStartOfStay: 'Age of guests on 1st day of the stay.',
    participantsSign: 'Entering the age of the participants allows you to immediately have the exact price',
    saveParticipants: 'Confirm the traveller details',
    numParticipants: 'Who?',

    placeHolders: {
        domains: 'Ski area',
        regions: 'Regions',
        stations: 'Stations',
        packages: 'Packages',
        lodgingType: 'Type of accommodation',
        autocomplete: 'Regions, Ski area, Resorts, accommodations ...',
        autocompleteSummer: 'Regions, Resorts, accommodations ...',
        topStations: 'Top stations',
        accommodations: 'Accommodations',
        noResults: 'No result for'
    },
    search: 'Search',
    reset: 'Reset',
    topStations: '',
    package: {
        days: "",
        title_PF: "",
        title_PFP: "",
        accomodation: "",
        skipass: "",
        equipment: "",
    },
}